import HTTP_API from "../store/constant/httpApi";

function generateMosaicUrl(id, year) {
  // const baseUrl = `${HTTP_API.TITILER}/mosaicjson/tiles/{z}/{x}/{y}@2x.png`;
  // const params = [];
  //
  // params.push("pixel_selection=highest");
  // params.push("TileMatrixSetId=WebMercatorQuad");
  // if (typeof year === "string") {
  //   params.push(`url=${HTTP_API.PRESET_MOSAICJSON}/${id}_${year}.json`);
  // } else if (Array.isArray(year)) {
  //   params.push(`url=${HTTP_API.PRESET_MOSAICJSON}/${id}_${year.join("-")}.json`);
  // }
  //
  // params.push("unscale=false");
  // params.push("resampling=nearest");
  // params.push("return_mask=true");
  // return `${baseUrl}?${params.join("&")}`;

  let url = ``;
    if (typeof year === "string") {
      url = `${HTTP_API.PRESET_MOSAICJSON}/${id}_${year}`;
  } else if (Array.isArray(year)) {
      url = `${HTTP_API.PRESET_MOSAICJSON}/${id}_${year.join("-")}`;
    }
  const baseUrl = `${HTTP_API.TITILER}/mosaicjson/tiles/WebMercatorQuad/{z}/{x}/{y}`;
  return `${baseUrl}?url=${url}.json`;

}

export default generateMosaicUrl;
